import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ArticleSubCategories = React.lazy(() => import('./index'));
const ArticleSubCategoryTable = React.lazy(() => import('./articleSubCategoryTable'));
const ArticleSubCategory = React.lazy(() => import('./articleSubCategory'));
const ArticleSubCategoryDetail = React.lazy(() => import('./articleSubCategoryDetail'));
const AddNewArticleSubCategory = React.lazy(() => import('./addNewArticleSubCategory'));
const EditArticleSubCategory = React.lazy(() => import('./editArticleSubCategory'));

export const useArticleSubCategoryRoutes = () => {

    return (
        <Route path="articleSubCategories" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubCategories /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubCategoryTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewArticleSubCategory/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubCategory/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleSubCategoryDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditArticleSubCategory/></Suspense> } />
            </Route>
        </Route>
    )
}